import uuidV4 from 'uuid/v4';

export default class Element {
	constructor(r) {
		this.item = {};
		if(r != false) {
			this.item = r;
		}

		this.defaults();
	}

	isset(key) {
		if(typeof this.item[key] === 'undefined') {
			return false;
		}

		return true;
	}

	output() {
		return this.item;
	}

	defaults() {
		if(!this.isset('type')) {
			this.item.type = false;
		}

		if(!this.isset('rowId')) {
			this.item.rowId = false;
		}

		if(!this.isset('col')) {
			this.item.col = 1;
		}

		if(!this.isset('sorting')) {
			this.item.sorting = 1;
		}
		
		if(!this.isset('id')) {
			this.item.id = uuidV4();
		}
	}
}


// WEBPACK FOOTER //
// ./helpers/element.js